import React from "react";
import { Grid } from "Components/Base/Layout";
import { Box } from "Components/Base/Layout/Box";
import { Pagination } from "Components/Base/Navigation/Pagination";

/**
 * CenteredPagination component displays pagination controls centered on the page
 * @param {Object} props - Component props
 * @param {number} props.maxPages - Maximum number of pages
 * @param {number} props.currentPage - Current active page
 * @param {Function} props.onPageChange - Callback function called when page changes
 * @returns {JSX.Element} CenteredPagination component
 */
const CenteredPagination = ({ maxPages, currentPage, onPageChange }) => {
  return (
    <Grid container justifyContent="center">
      <Box m={5}>
        <Pagination
          count={maxPages}
          onChange={(_, pageNum) => onPageChange(pageNum)}
          page={currentPage}
        />
      </Box>
    </Grid>
  );
};

export default CenteredPagination;

